// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"722":"2175a667","884":"dc85e977"}[chunkId] + ".chunk.js";
};